<template>  <div
    class="gradient"
    :style="{
      'height': Number(fontsize) + 10 + 'px',
      'line-height': Number(fontsize) + 10 + 'px',
    }"
  >
    <span
      :style="{
        'font-size': fontsize + 'px',
        'color': fontcolor,
        'background': bgColor
      }"
    >
      {{ title }}
    </span>
  </div></template><script> export default {
    name: "bdGradientTitle",
    props: ["title", "fontsize", "fontcolor", "gradientcolor"],
    computed: {
        bgColor() {
            const color = this.changeRgbaOpacity(this.gradientcolor, 0.3);
            return `linear-gradient(to right, transparent, ${color} 50px, transparent 100%)`;
        }
    },
    methods: {
        changeRgbaOpacity(rgba, opacity) {
            const parts = rgba.match(/(\d+)/g);
            if (parts && parts.length === 4) {
                const [r, g, b] = parts;
                return `rgba(${r}, ${g}, ${b}, ${opacity})`;
            } else {
                return rgba; // 如果格式不正确，返回原始值
            }
        }
    }
}</script><style scoped>  .gradient span {
      display: inline-block;
      width: 100%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
  }</style>